import template from './page-navigation.html';
import controller from './page-navigation.controller';

import './page-navigation.styl';

let pageNavigationComponent = {
  restrict: 'E',
  bindings: {
      highlight: '=',
      disabled: '=',
      next: '@',
      prev: '@'
  },
  template,
  controller
};

export default pageNavigationComponent;



// WEBPACK FOOTER //
// ./client/app/common/page-navigation/page-navigation.component.js